import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  PaymentConfiguration,
  isConfigurationReady
} from "../../../types/payments";
import { semanticColors } from "../../../utils/colors";
import { typography } from "../../../utils/typography";

/**
 * Whether a configuration is complete enough to be used.
 *
 * This reflects `isConfigurationReady`, which is the visual indicator, and is
 * deliberately a slightly different check from the functional gate that decides
 * whether a configuration can charge a patient.
 */
export default function ConfigurationReadyChip({
  configuration
}: {
  configuration: PaymentConfiguration;
}) {
  const { t } = useTranslation();
  const ready = isConfigurationReady(configuration);

  return (
    <Chip
      label={
        ready
          ? t("paymentConfigurations.ready")
          : t("paymentConfigurations.needsInformation")
      }
      clickable={false}
      sx={{
        color: semanticColors.text.inverse,
        ...typography.body.mBold,
        backgroundColor: ready
          ? semanticColors.status.completed
          : semanticColors.status.inProgress,
        borderRadius: "20px",
        height: "24px",
        minWidth: "128px"
      }}
    />
  );
}
